import script from "./AssetPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetPage.vue?vue&type=script&setup=true&lang=ts"

import "./AssetPage.vue?vue&type=style&index=0&id=66b8d144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b8d144"]])

export default __exports__